import { createSlice } from "@reduxjs/toolkit";

const { reducer, actions } = createSlice({
    name: "applications",
    initialState: {
        dialog: undefined,
        haveRoute: false,
    },
    reducers: {
        dialog(state, action) {
            state.dialog = action.payload;
        },
        haveRoute(state, action) {
            state.haveRoute = action.payload;
        },
    },
});

export { actions };
export { reducer };
